var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"14","height":"4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 .833h14v2.334H0V.833z","fill":"#4C4541"}})])}
var staticRenderFns = []

export { render, staticRenderFns }